import { useDialogs } from '@shared/hooks/dialogs'

import Button from '@mui/material/Button'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import MotionDialog from '@shared/components/MotionDialog'

export default function Welcoming({
    user,
    onClose
}) {
    const { show } = useDialogs()
    const handleSetSignature = () => {
        onClose()
        show('user', {instance: user})
    }

    return (
        <MotionDialog
            onClose={onClose}
        >
            <DialogTitle>م. {user.first_name} {user.last_name}</DialogTitle>
            <DialogContent>
                <DialogContentText>أهلاً بك في النظام الجديد. ارجو منك ان تقوم بإعادة تعيين توقيعك ليعمل النظام بسلاسة.</DialogContentText>
                <br/>
                <DialogContentText>
                    مميزات النظام الجديد:<br/>
                    - إنتهاء مشكلة (حدث خطأ لكثرة الصور).<br/>
                    - نماذج إلكترونية اكثر واقعية.<br/>
                    - توحيد الصفحات في صفحة (المقايسات).
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>لاحقاً</Button>
                <Button onClick={handleSetSignature}>تعيين</Button>
            </DialogActions>
        </MotionDialog>
    )
}